import type { FC } from "react";

import { Modal, Text } from "@alpacahq/ui/old";

import type { AcatsTransfer } from "~/v2/api/rest/acats";

// Map rejection reasons to user-friendly text.
// Keyed by `string` so unknown backend rejection reasons look up as `undefined`.
const REJECTION_REASON_MAP: Record<string, string> = {
  SS_TAX_ID_MISMATCH: "Tax ID Mismatch",
  ACCOUNT_TITLE_MISMATCH: "Account Title Mismatch",
  DOCUMENTATION_NEEDED: "Documentation Needed",
  ACCOUNT_FLAT: "Account Flat",
  INVALID_ACCOUNT_NUMBER: "Invalid Account Number",
  DUPLICATE: "Duplicate Transfer",
  ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER: "Account in Distribution or Transfer",
  CLIENT_RESCINDED: "Client Rescinded",
  MISSING_AUTHORIZATION_SIGNATURE: "Missing Authorization Signature",
  ACCOUNT_VIOLATES_CREDIT_POLICY_OF_RECEIVING_FIRM:
    "Account Violates Credit Policy",
  UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE:
    "Unrecognized for Residual Credit Balance",
  PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT:
    "Partial Transfer Deliverer Initiated Reject",
  FAIL_REVERSAL_REJECT: "Fail Reversal Reject",
  RECLAIM_REJECT: "Reclaim Reject",
  MUTUAL_FUND_CLEANUP: "Mutual Fund Cleanup",
  SYSTEM_REJECTED: "System Rejected",
};

type RejectionDetailsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  transfer: AcatsTransfer | null;
};

export const RejectionDetailsModal: FC<RejectionDetailsModalProps> = ({
  isOpen,
  onClose,
  transfer,
}) => {
  if (!transfer?.rejection_details) {
    return null;
  }

  const { rejection_reason, rejection_message } = transfer.rejection_details;
  const friendlyReason =
    REJECTION_REASON_MAP[rejection_reason] || rejection_reason;

  return (
    <Modal
      size="xs"
      title="Note"
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="p-5"
      contentClassName="flex w-full flex-col justify-center space-y-1" // Use of space-y required to fix the layout issue
    >
      <div className="grid gap-2">
        <div>
          <Text className="font-normal text-gray-700 text-sm">
            Your Portfolio Transfer is rejected due to the below reason(s):
          </Text>
        </div>

        <div className="grid gap-1">
          {friendlyReason && (
            <div>
              <Text className="font-medium text-gray-800 text-sm">{`${friendlyReason}`}</Text>
            </div>
          )}
          {rejection_message && (
            <div>
              <Text className="font-normal text-gray-700 text-sm">
                {`${rejection_message}`}
              </Text>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
